import React, { useRef } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import AuthPromoTextPopup from 'apps/auth/components/calculator/AuthPromoTextPopup';
import { NavBar } from 'apps/auth/components/common/Layout/NavBar/NavBar';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import { ALIPAY_FREE, MASTERCARD_FREE } from 'apps/auth/constants/FieldType';
import { URL_IMAGES_PAYSYSTEMS } from 'apps/auth/constants/UrlConstants';
import zIndex from 'apps/auth/theme/zIndex';

const IconWrapper = styled.div`
    margin-right: 24px;
`;

const MainWrapper = styled.div`
    z-index: ${zIndex.promoBanner};
`;

const AuthPromoBanner = (props) => {
    const popupRef = useRef(null);
    const isComponentType = (type) => props.component !== null && props.component.type === type;

    const getIcon = () => {
        if (isComponentType(ALIPAY_FREE)) {
            return { url: `${URL_IMAGES_PAYSYSTEMS}/alipay.svg` };
        } else if (isComponentType(MASTERCARD_FREE)) {
            return { url: `${URL_IMAGES_PAYSYSTEMS}/mastercard_color.svg` };
        }
    };

    if (isComponentType(ALIPAY_FREE) || isComponentType(MASTERCARD_FREE)) {
        return (
            <>
                <MainWrapper>
                    <NavBar align="center">
                        <IconWrapper>
                            <img src={getIcon()} alt={'paysystem'} />
                        </IconWrapper>
                        <Row flex direction="column">
                            <Text>{props.component.title}</Text>
                            <Text
                                variant="button"
                                color="primary"
                                onClick={() =>
                                    popupRef.current?.open(
                                        <AuthPromoTextPopup
                                            popupRef={popupRef}
                                            countryToId={props.countryToId}
                                            isComment
                                            text={props.component.modalBlockText}
                                        />,
                                    )
                                }
                            >
                                {props.component.moreText}
                            </Text>
                        </Row>
                    </NavBar>
                </MainWrapper>
                <PopupNew ref={popupRef} />
            </>
        );
    } else {
        return null;
    }
};

const mapStateToProps = (state) => {
    return {
        countryToId: state.extra.countryToId,
        component: state.app.authPromoAction,
    };
};

export default connect(mapStateToProps, null)(AuthPromoBanner);
